import { apiRequest } from "./api";

export const statsService = {
  // Get impact statistics
  getStats: async () => {
    return await apiRequest("/stats", {
      method: "GET",
      requiresAuth: false,
    });
  },
};
